import { render, staticRenderFns } from "./registerRecord.vue?vue&type=template&id=19ae7297&"
import script from "./registerRecord.vue?vue&type=script&lang=js&"
export * from "./registerRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19ae7297')) {
      api.createRecord('19ae7297', component.options)
    } else {
      api.reload('19ae7297', component.options)
    }
    module.hot.accept("./registerRecord.vue?vue&type=template&id=19ae7297&", function () {
      api.rerender('19ae7297', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/oilActivityManage/registerActivity/registerRecord.vue"
export default component.exports